import { Box, Display, Image, JustifyContent } from '@gousto-internal/citrus-react'
import React from 'react'
import LoadingIcon from './LoadingIcon.png'

export const CuratedBoxLoader = () => {
  return (
    <Box
      data-testid="curatedBoxLoader"
      display={Display.Flex}
      justifyContent={JustifyContent.Center}
      paddingV={16}
    >
      <Image alt="Curated Box Loader" src={LoadingIcon} width="10%" />
    </Box>
  )
}
